<template>
  <v-tabs color="primary" slider-color="blue-darken-3">
    <v-tab :to="{ name: `document-preview` }" replace> Документ </v-tab>
    <v-tab
      v-if="!acceptanceStatus.isInAcceptanceList"
      :to="{ name: `document-requisites` }"
      replace>
      Реквізити
    </v-tab>
    <v-tab
      v-if="allowsRoutes && !acceptanceStatus.isInAcceptanceList"
      :to="{ name: `document-route` }"
      replace>
      Маршрут погодження
    </v-tab>
    <v-tab
      v-if="
        !acceptanceStatus.isInAcceptanceList &&
        documentSource.docTypeClassId !== 3 // Вхідні
      "
      :to="{ name: `document-acceptance` }"
      replace>
      Ознайомлення
    </v-tab>
    <v-tab :to="{ name: `document-relation` }" replace> Звʼязки </v-tab>
    <v-tab
      v-if="!acceptanceStatus.isInAcceptanceList"
      :to="{ name: `document-versions` }"
      replace>
      Версії
    </v-tab>
    <v-tab
      v-if="!acceptanceStatus.isInAcceptanceList"
      :to="{ name: `document-attachments` }"
      replace>
      Вкладення
    </v-tab>
    <v-tab :to="{ name: `document-history` }" replace> Історія </v-tab>
    <v-tab :to="{ name: `document-comments` }" replace> Коментарі </v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import { ComputedRef } from 'vue'
import { useDocument } from '../document'

defineProps<{
  allowsRoutes: boolean | ComputedRef<boolean>
}>()

defineOptions({
  name: 'DocumentTabs',
})

const { acceptanceStatus, documentSource } = useDocument()
</script>
